// Wordmark compartido de SivarSend.
//
// Se extrajo porque el mismo JSX estaba repetido en seis pantallas de
// Desarrollos (login, intake, perfil, Mi Anexo, placeholder y el shell del
// operador) y el recolor de "Send" a teal habría que hacerlo seis veces.
//
// Nota: Comando Ops resuelve su logo desde tenants.logo_url vía TenantContext
// (ver LoginPortal.js). Desarrollos se monta FUERA del TenantProvider a
// propósito, así que no puede usar ese camino: acá el wordmark es estático.
// No hay asset de imagen en public/ todavía — cuando exista, va al lado del
// texto a la misma altura.

const TAMANOS = {
  sm: { texto: 'text-base', sub: 'text-[10px]' },
  md: { texto: 'text-2xl', sub: 'text-xs' },
  lg: { texto: 'text-3xl', sub: 'text-sm' },
};

const SivarSendWordmark = ({ size = 'md', subtitle, className = '' }) => {
  const t = TAMANOS[size] || TAMANOS.md;
  return (
    <div className={className}>
      <div className={`${t.texto} font-bold leading-none tracking-tight`}>
        <span className="text-slate-900">Sivar</span>
        <span style={{ color: 'var(--brand-teal)' }}>Send</span>
      </div>
      {subtitle && (
        <div className={`${t.sub} mt-1.5 font-normal text-slate-400`}>{subtitle}</div>
      )}
    </div>
  );
};

export default SivarSendWordmark;
